import { render, staticRenderFns } from "./ResponseTemplateCard.vue?vue&type=template&id=679ded2e&scoped=true"
import script from "./ResponseTemplateCard.vue?vue&type=script&lang=js"
export * from "./ResponseTemplateCard.vue?vue&type=script&lang=js"
import style0 from "./ResponseTemplateCard.vue?vue&type=style&index=0&id=679ded2e&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "679ded2e",
  null
  
)

export default component.exports